<iframe class="iframe-bdc" scrolling="yes" frameborder="0" [src]="signatureService.getUrlSignature()" (load)="onLoadIframe()"
  [ngClass]="{'report-error': isErrorReport}">
</iframe>
